import React, { forwardRef } from 'react';

import { PlusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import st from '../popovers.module.sass';
import { MetaFilterRow } from './meta/MetaFilterRow';
import { useMetaFilters } from './meta/useMetaFilters';

function MetaFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useEventListFiltersTranslation();
  const {
    rows, updateRow, addRow, removeRow, clear,
  } = useMetaFilters();

  return (
    <PopoverWithButton
      {...props}
      className={st.ScrollableWrapper}
      isButtonDisabled={rows.length === 0}
      onClickReset={clear}
      ref={ref}
    >
      {rows.map((item, index) => (
        <React.Fragment
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        >
          <MetaFilterRow
            index={index}
            item={item}
            onChange={updateRow}
            onRemove={removeRow}
          />
          <div className={st.Divider} />
        </React.Fragment>
      ))}

      <Button
        data-testid="meta.plusIcon"
        icon={<PlusIcon />}
        kind="primary"
        onClick={addRow}
        title={t('meta_add')}
        variant="flat"
      >
        {t('meta_add')}
      </Button>
    </PopoverWithButton>
  );
}

const MetaFilterPopoverWithRef = forwardRef(MetaFilterPopover);
export { MetaFilterPopoverWithRef as MetaFilterPopover };
